import React from 'react'

export default function CustomerCreditAccountHeaderStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        .customer-details-title-container {
          display: flex;
        }

        .customer-details-title {
          flex: 1;
        }
      `}
      </style>
    </React.Fragment>
  )
}
